import config from '../../helpers/config-helper';

const appConfig = config();
// const baseURL = appConfig.REACT_APP_PUBLIC_URL;
const baseURL = '/DIDInnovateHub';
const RoutesConstants = {
  Login: baseURL + '/Login',
  Logout: baseURL + '/Logout',
  OmsUser: baseURL + '/OmsUser',
  UserManagement: baseURL + '/UserManagement',
  TenantManagement: baseURL + '/FactoryManagement',
  FactoryManagement: baseURL + '/FactoryManagement',
  BranchManagement: baseURL + '/BranchManagement',
  MediaManagement: baseURL + '/MediaManagement',
  ParkingLotManagement: baseURL + '/ParkingLotManagement',
  IntegratorManagement: baseURL + '/IntegratorManagement',
  CameraManagement: baseURL + '/CameraManagement',
  FoldersManagement: baseURL + '/ManageFolders',
  PriceScheduler: baseURL + '/PriceScheduler',
  UserLogs: baseURL + '/UserLogs',
  SystemLogs: baseURL + '/SystemLogs',
  Products: baseURL + '/Products',
  WeightedProducts: baseURL + '/WeightedProducts',
  AccountActivation: baseURL + '/AccountActivation',
  OrderManagement: baseURL + '/OrderManagement',
  RecipeManagement: baseURL + '/RecipeManagement',
  ProcessManagement: baseURL + '/ProcessManagement',
  StepManagement: baseURL + '/StepManagement',
  StepManagementOperator: baseURL + '/StepManagementOperator',
  FactoryHeadUserManagement: baseURL + '/FactoryHeadUserManagement',
  AIMSPortal: baseURL + '/AIMSPortal',
  FactorySchedule: baseURL + '/FactorySchedule',
  ProcessTemplateManagement: baseURL + '/ProcessTemplateManagement',
  HolidayCalendar: baseURL + '/HolidayCalendar',
  TeplarPrintTemplateManagement: baseURL + '/TeplarPrintTemplateManagement',
  ProductManagement: baseURL + '/ProductManagement',
  TrayManagement: baseURL + '/TrayManagement',
  GroupManagement: baseURL + '/GroupManagement',
  ProductionManagerUserManagement: baseURL + '/ProductionManagerUserManagement',
  ActiveTrayManagement: baseURL + '/ActiveTrayManagement',
  ProcessWiseChart: baseURL + '/ProcessWiseChart',
  OrderTableView: baseURL + '/OrderTableView',
  HKRDashboarData: baseURL + '/HKRDashboardData',
  KishuManagement: baseURL + '/KishuManagement',
  OperatorListDetail: baseURL + '/OperatorListDetail',
  OperatorAssignTask: baseURL + '/OperatorAssignTask',
  OperatorTagAssign: baseURL + '/OperatorTagAssign',
  OperatorImageAssign: baseURL + '/OperatorImageAssign',
  OperatorAssignSpecialTask: baseURL + '/OperatorAssignSpecialTask',
  OperatorAssignSpecialTask1: baseURL + '/OperatorAssignSpecialTask1', // Remove Later only for demo purpose.
  FactoryAccess: baseURL + '/FactoryAccess',
  Preprocessing: baseURL + '/Assembly',
  Assembly: baseURL + '/Preprocessing',
  DimensionTableFields: baseURL + '/DimensionTableFields',
  CheckItemTemplate: baseURL + '/CheckItemTemplate',
  TrayTagReassignment: baseURL + '/TrayTagReassignment',
  BomSearch: baseURL + '/BomSearch',
  PartsSearch: baseURL + '/PartsSearch',
  MaterialTagAssign: baseURL + '/BOM/MaterialTagAssign',
};
export default RoutesConstants;
